import React from 'react'
import { useFulfillment } from '../FulfillmentProvider/FulfillmentProvider'
import { useDate } from '../../hooks/useDate'

interface FutureEstimateProps {
  textClass?: string
}

export const FutureEstimate: React.FC<FutureEstimateProps> = ({
  textClass = 'text-default'
}) => {
  const { fulfillmentDateTime } = useFulfillment()
  const { toRelativeDateString, toFormatedHours } = useDate()

  const fulTime = fulfillmentDateTime || new Date().toISOString()

  const date = toRelativeDateString(fulTime)
  const time = toFormatedHours(fulTime)

  return (
    <>
      <span
        data-testid='fulfillment-scheduled-ready-date'
        className={textClass}
      >
        {date}
      </span>
      ,
      <span
        data-testid='fulfillment-scheduled-ready-time'
        className={`whitespace-nowrap ${textClass}`}
      >
        &nbsp;{time}
      </span>
    </>
  )
}
